// UI and logic for signing the user out.
import { useT } from '@/i18n/useT';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOutUser } from '@/services/authService';

const LogoutPage = () => {
  const t = useT();
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await signOutUser();
        // Redirect after successful logout
        navigate('/'); // Redirect to the home page
      } catch (_error) {
        // Error is already logged in authService
      }
    };

    handleLogout();
  }, [navigate]);

  return <div>{t('logout.loading', 'Logging out...')}</div>;
};

export default LogoutPage;
